export class NotAccountOwnerError extends Error {
  constructor() {
    super(`It's not account owner`);
    this.message = 'NotAccountOwnerError';
  }
}
